   import React, { useState, useEffect, useRef, useCallback  } from 'react';
import { BiSearchAlt2 } from "react-icons/bi";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoClose } from "react-icons/io5";
import OtherUsers from './OtherUsers';
import axios from "axios";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setAuthUser, setOtherUsers, setSelectedUser, addMoreUsers , setPagination, resetPagination,clearSearchResults,  setSearchResults } from '../redux/userSlice';
import { setMessages } from '../redux/messageSlice';
import { BASE_URL } from '../config';
import { Oval } from 'react-loader-spinner';

const Sidebar = () => {
    const [search, setSearch] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [filter, setFilter] = useState('all'); // 'all', 'read', 'unread'
     const [isSpecialView, setIsSpecialView] = useState(false);
    const observer = useRef();

    const { otherUsers, unreadMessages, searchResults,allUsers,  pagination = { page: 1, hasMore: true, loadingMore: false }  } = useSelector(store => store.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();


    const toggleSidebar = () => setIsOpen(!isOpen);

      // New effect to clear search results when search input is empty
  useEffect(() => {
    if (search.trim() === '') {
      dispatch(clearSearchResults());
    }
  }, [search, dispatch]);


    useEffect(() => {
    dispatch(clearSearchResults());
    setSearch("");
}, [filter, dispatch]);

 // Update filter handler to track view mode
  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
    setIsSpecialView(newFilter !== 'all' || search.trim() !== '');
  };

  useEffect(() => {
  if (filter === 'all' && search.trim() === '') {
    setIsSpecialView(false);
  }
}, [filter, search]);

    const logoutHandler = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/api/v1/user/logout`);
            navigate("/login");
            toast.success(res.data.message);
            dispatch(setAuthUser(null));
            dispatch(setMessages(null));
            dispatch(setOtherUsers([]));
            dispatch(setSelectedUser(null));
        } catch (error) {
            console.log(error);
        }
    }

    
const filterNonAdminUsers = (userList) => {
    if (!Array.isArray(userList)) return [];
    return userList.filter(user => user?.isRole !== 1); // Handle undefined users
};

    // const searchSubmitHandler = (e) => {
    //     e.preventDefault();
    
    //     if (!Array.isArray(allUsers)) {
    //         toast.error("User list is not available!");
    //         return;
    //     }
    
    //     const filteredUsers = allUsers.filter(user =>
    //         user.username !== 'OnexChat' &&
    //         user.isRole !== 1 && // Exclude admin users
    //         user.username.toLowerCase().includes(search.toLowerCase())
    //     );
    
    //     if (filteredUsers.length > 0) {
    //         dispatch(setOtherUsers(filteredUsers));
    //         setPage(1); // Reset to first page when searching
    //         setHasMore(filteredUsers.length > 10);

    //     } else {
    //         toast.error("User not found!");
    //     }
    // };

//     const searchSubmitHandler = async (e) => {
//     e.preventDefault();
//       dispatch(resetPagination());
//     try {
//         const { data } = await axios.get(`${BASE_URL}/api/v1/user/search?query=${search}`);
//         const filtered = data.filter(u => u.isRole !== 1 && u.username !== 'OnexChat' && u.username.toLowerCase().includes(search.toLowerCase())) ;
        
//         if(filtered.length > 0) {
//             dispatch(setOtherUsers(filtered));
//             // setPage(1);
//             // setHasMore(false); // Disable infinite scroll during search
//           dispatch(setPagination({ hasMore: false }));

//         } else {
//             toast.error("User not found!");
//         }
//     } catch (error) {
//         toast.error("Search failed");
//     }
// };

const searchSubmitHandler = async (e) => {
    e.preventDefault();
    if (!search.trim()) {
        dispatch(clearSearchResults());
        setIsSpecialView(false); 
        return;
    }
    
    try {
        const { data } = await axios.get(`${BASE_URL}/api/v1/user/search?query=${search}`);
        dispatch(setSearchResults(data));
            setIsSpecialView(true); 
    } catch (error) {
        toast.error("Search failed");
    }
};


      // Filter users based on read/unread status
    //   const getFilteredUsers = () => {
    //      if (!Array.isArray(otherUsers)) return [];
         
    //     // const nonAdminUsers = otherUsers.filter(user => user.isRole !== 1);
    //       const nonAdminUsers = otherUsers.filter(user => user && user.isRole !== 1);

    //     if (filter === 'all') return nonAdminUsers;
        
    //     return nonAdminUsers.filter(user => {
    //         if (filter === 'unread') {
    //             return unreadMessages[user._id] > 0;
    //         } else { // read
    //             return !unreadMessages[user._id] || unreadMessages[user._id] === 0;
    //         }
    //     });
    // };
//              const getFilteredUsers = () => {
//     // Always start with a safe array
//     // const safeUsers = Array.isArray(otherUsers) ? otherUsers : [];
    
//     // return safeUsers
//       return [...otherUsers]
//         .filter(user => 
//             user?._id && // Validate user object
//             user.isRole !== 1 
//             // user.username !== 'OnexChat'
//         ) .sort((a, b) => {
//             const timeA = new Date(a.lastMessageTime || 0);
//             const timeB = new Date(b.lastMessageTime || 0);
//             return timeB - timeA; // Sort by latest message first
//         })
//         .filter(user => {
//             if (filter === 'all') return true;
//             const unread = unreadMessages[user._id] || 0;
//             return filter === 'unread' ? unread > 0 : unread === 0;
//         });
// };

const getFilteredUsers = () => {
    const usersToShow = searchResults || otherUsers;
    
    return usersToShow
        .filter(user => 
            user?._id && 
            user.isRole !== 1
        )
        .sort((a, b) => {
            const timeA = new Date(a.lastMessageTime || 0);
            const timeB = new Date(b.lastMessageTime || 0);
            return timeB - timeA;
        })
        .filter(user => {
            if (filter === 'all') return true;
            const unread = unreadMessages[user._id] || 0;
            return filter === 'unread' ? unread > 0 : unread === 0;
        });
};

    const loadMoreUsers = useCallback(async () => {
    // if (!hasMore || loadingMore) return;
    // setLoadingMore(true);
    
            if (!pagination?.hasMore || pagination?.loadingMore) return;
        
        dispatch(setPagination({ loadingMore: true }));

    try {
        const response = await axios.get(`${BASE_URL}/api/v1/user?page=${pagination.page}&limit=10`);

          if (response.status === 200) {
        const newUsers = response.data?.users || [];

                    // Filter out users already present (in case of real-time additions)
            const filteredNewUsers = newUsers.filter(newUser => 
                !otherUsers.some(existing => existing._id === newUser._id)
            );
            

        
        if(filteredNewUsers.length > 0) {
            dispatch(addMoreUsers(filteredNewUsers));
              dispatch(setPagination({ 
                    page: pagination.page + 1,
                    hasMore: response.data?.pagination?.hasNextPage || false,
                    loadingMore: false
                }));
   
      }
    }
    } catch (error) {
        console.error("Error loading more users:", error);
        toast.error("Failed to load more users");
    
          dispatch(setPagination({ loadingMore: false }));
    }

}, [pagination, otherUsers, dispatch]);

    // Infinite scroll observer
    const lastUserElementRef = useCallback(node => {

          // Skip observer setup in special views
    if (isSpecialView) {
      if (observer.current) observer.current.disconnect();
      return;
    }
    
    
        if (pagination.loadingMore || !pagination.hasMore) return;
        if (observer.current) observer.current.disconnect();
        
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                loadMoreUsers();
            }
        });
        
        if (node) observer.current.observe(node);
    }, [pagination.loadingMore, pagination.hasMore, loadMoreUsers, isSpecialView]);

    // Initial load
    useEffect(() => {
        loadMoreUsers();
    }, []);

    return (
        <>
            {/* Mobile Menu Button (Now on the Right Side) */}
            {/* <button onClick={toggleSidebar} className="md:hidden p-3 text-black rounded-md fixed top-2 right-2 z-50">
                <GiHamburgerMenu size={24} />
            </button> */}

            {/* Sidebar */}
            {/* <div className={`fixed md:relative top-0 left-0 h-full bg-white border-r border-gray-300 p-4 flex flex-col transition-transform duration-300 ease-in-out
                ${isOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0 w-64 md:w-80 lg:w-96 z-40 `}> */}
               <div className='h-full bg-white border-r border-gray-300 p-4 flex flex-col w-full md:w-64 lg:w-80 z-40'>
                {/* Close Button for Mobile */}
                {/* <button onClick={toggleSidebar} className="md:hidden self-end p-2">
                    <IoClose size={24} />
                </button> */}

                {/* Search Input */}
                <form onSubmit={searchSubmitHandler} className='flex items-center gap-2'>
                    <input
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className='border px-3 py-2 rounded-md w-full'
                        type="text"
                        placeholder='Search users...'
                    />
                    <button type='submit' className='bg-zinc-700 text-white px-3 py-2 rounded-md'>
                        <BiSearchAlt2 size={20} />
                    </button>
                </form>

                                {/* Read/Unread Filter Buttons */}
                                <div className="flex gap-2 mt-3">
                    <button 
                        // onClick={() => {
                        //     setFilter('all');
                        //     // setPage(1);
                        //     dispatch(resetPagination());
                        //  }}
                           onClick={() => handleFilterChange('all')}
                        className={`flex-1 py-2 rounded-md text-sm ${filter === 'all' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
                    >
                        All
                    </button>
                    <button 
                        // onClick={() => {setFilter('read');
                        //                 //  setPage(1);
                        //                 dispatch(resetPagination());
                        // }
                        // }
                           onClick={() => handleFilterChange('read')}
                        className={`flex-1 py-2 rounded-md text-sm ${filter === 'read' ? 'bg-green-500 text-white' : 'bg-gray-200'}`}
                    >
                        Read
                    </button>
                    <button 
                        // onClick={() => {
                        //     setFilter('unread');
                        //     // setPage(1);
                        //     dispatch(resetPagination());
                        // }}
                           onClick={() => handleFilterChange('unread')}
                        className={`flex-1 py-2 rounded-md text-sm ${filter === 'unread' ? 'bg-red-500 text-white' : 'bg-gray-200'}`}
                    >
                        Unread
                    </button>
                </div>


                <div className="border-b my-3"></div>

                {/* User List */}
                <OtherUsers users={getFilteredUsers()}  lastUserElementRef={lastUserElementRef}/>

                  {pagination.loadingMore && (
                <div className="flex justify-center my-2">
                    <Oval
                        height={30}
                        width={30}
                        color="#4fa94d"
                        visible={true}
                        ariaLabel='oval-loading'
                        secondaryColor="#4fa94d"
                        strokeWidth={2}
                        strokeWidthSecondary={2}
                    />
                </div>
            )}
                
                {/* Logout Button */}
                {/* <div className='mt-auto'>
                    <button onClick={logoutHandler} className='bg-zinc-300 text-black font-bold px-4 py-2 rounded-lg w-full'>
                        Logout
                    </button>
                </div> */}
                <div className='mt-auto flex flex-col gap-2'>
                    <button
                        onClick={() =>  {
                            setIsOpen(false); // Close sidebar on mobile
                            navigate("/admin-dashboard" , { state: { resetPage: true } });
                        }}
                        className='md:hidden bg-zinc-300 text-black font-bold px-4 py-2 rounded-lg w-full'
                    >
                        Back
                    </button>

                    {/* <button
                        onClick={logoutHandler}
                        className='bg-zinc-300 text-black font-bold px-4 py-2 rounded-lg w-full'
                    >
                        Logout
                    </button> */}
                </div>
            </div>

            {/* Overlay for Mobile */}
            {/* {isOpen && (
                <div onClick={toggleSidebar} className="fixed inset-0 bg-black opacity-50 md:hidden z-30"></div>
            )} */}
        </>
    );
}

export default Sidebar; 